import React , {createContext , useContext, useState } from 'react'

const PayoutContext = createContext()


const PayoutContextProvider = ({children})=>{

     const [ loader , setLoader ] = useState(false)
     const [ currentPage , setCurrentPage ] = useState('start')
    return (
         <PayoutContext.Provider value={{ loader , setLoader , setCurrentPage , currentPage }}>
            {children}
         </PayoutContext.Provider>
    )
}

export const usePayoutContext = ()=> useContext(PayoutContext)

export default PayoutContextProvider